import { CalendarClock } from "lucide-react";
import { cn } from "@/lib/utils";

type ScheduledOrderCycleSelectorProps = {
  years: number[];
  /** Ano do ciclo comercial ativo (status Open) no sistema. */
  activeYear: number | null;
  selectedYear: number | null;
  onSelect: (year: number) => void;
};

export function ScheduledOrderCycleSelector({
  years,
  activeYear,
  selectedYear,
  onSelect,
}: ScheduledOrderCycleSelectorProps) {
  if (years.length === 0) return null;

  return (
    <section aria-labelledby="scheduled-order-cycle-title" className="mb-6">
      <div className="mb-3">
        <h2 id="scheduled-order-cycle-title" className="text-sm font-semibold">
          Ciclo comercial
        </h2>
        <p className="text-xs text-muted-foreground">
          Selecione o ciclo dos pedidos programados que deseja visualizar.
        </p>
      </div>
      <div className="grid max-w-4xl grid-cols-1 gap-3 sm:grid-cols-3">
        {years.map((year) => {
          const isSelected = selectedYear === year;
          const cycleLabel =
            activeYear === null
              ? null
              : year === activeYear
                ? "Ciclo Atual"
                : year < activeYear
                  ? "Ciclo Anterior"
                  : "Próximo Ciclo";

          return (
            <button
              key={year}
              type="button"
              onClick={() => onSelect(year)}
              aria-pressed={isSelected}
              className={cn(
                "flex items-center gap-3 rounded-lg border bg-card px-4 py-3 text-left transition-colors",
                "hover:border-primary/60 hover:bg-primary/5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
                isSelected && "border-primary bg-primary/10 ring-1 ring-primary",
              )}
            >
              <span className={cn("rounded-full p-2", isSelected ? "bg-primary text-primary-foreground" : "bg-muted text-muted-foreground")}>
                <CalendarClock className="h-4 w-4" aria-hidden="true" />
              </span>
              <span>
                <span className="block font-semibold">Ciclo {year}</span>
                {cycleLabel && (
                  <span className="block text-xs text-muted-foreground">{cycleLabel}</span>
                )}
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
